import React from 'react'
import { ProfileSettingsPageView } from './view'
import { ProfileSettingsPageLogic } from './logic'

export const ProfileSettingsPage: React.FC = () => {
  return (
    <ProfileSettingsPageLogic>
      <ProfileSettingsPageView />
    </ProfileSettingsPageLogic>
  )
}
